module.exports = __webpack_public_path__ + "img/drone_05_H.9108b4a8.webp";